var exports = {
  "K": "x31de4314--65f20c--icon",
};

module.exports = exports;
